<template lang="pug">
v-container(
  fluid
  pa-0
  px-4
  ma-0
  py-1
)
  v-row(dense justify-space-between align="center")
    v-col(cols="auto")
      div(@click="$router.push({ name: 'inboxItem', params: { id: lead.id } })" class=" tw-rounded tw-overflow-hidden ")
        v-img(v-if="lead.property.main_image" :src="path(lead.property.main_image.path)" width="52px" aspect-ratio="1")
    v-col(cols="stretch")
      v-row(no-gutters)
        v-col
          router-link(class="tw-font-medium text-link" :to="{ name: 'inboxItem', params: { id: lead.id } }") {{ lead.name }} {{ lead.last_name }}
      v-row(no-gutters)
        v-col
          span(class=" tw-text-sm") {{ lead.property.address_street }}, {{ lead.property.address_city }}
    v-col(cols="auto")
      v-row(no-gutters)
        v-col
          span(class="tw-font-medium tw-text-gray-darken-3") {{ this.$moment(lead.created_at).fromNow() }}
</template>
<script>
export default {
  props: ['lead'],
};
</script>
